/**
 * A chat title with the Recents filter's first match marked, as the command
 * palette marks its matches.
 *
 * @module components/home/RecentThreadTitleMatch
 */
import { matchRange } from "./HomeSidebarRecents.logic";

export function RecentThreadTitleMatch({ text, query }: { readonly text: string; readonly query: string }) {
  const match = matchRange(text, query);
  if (match === null) return text;
  return (
    <>
      {text.slice(0, match.start)}
      <mark data-recents-match="" className="rounded-[3px] bg-sidebar-foreground/12 font-semibold text-foreground">
        {text.slice(match.start, match.end)}
      </mark>
      {text.slice(match.end)}
    </>
  );
}
